import styled from "styled-components";

const OpportunityCardContainer = styled.div`
.date{
    color:#39364f;
    font-weight: 400;
    font-size:18px;
}
.event-title{
    font-weight: 800;
    font-size:2.2rem;
}
.uppercase{
    text-transform:uppercase;
}
.fs-18{
    font-size:18px;
}
.grid-container{
    display:grid;
    grid-template-columns:1fr;

}
@media (min-width:768px){
    .event-title{
    font-size:3rem;
    }

}
@media (min-width:920px){
    .grid-container{
        display:grid;
        grid-template-columns:2fr 1fr;
    }   
}
.grid-item-2{
    align-self:start;
}
.location-grid{
    position:relative;
    display:grid;
    grid-template-columns:1fr;
}
.bg-grey{
    background-color:#dbdae3;
}
.when-details,.where-details{
    gap:10px;
    padding:10px;
}
.opportunity-image-wrapper{
    height: 200px;
    width:100%;
}
.opportunity-item{
    height:460px;
    background-color:#fff;
    overflow:hidden;
    box-shadow: 0 16px 64px -16px rgb(46 55 77 / 10%);
    .opportunity-card-details{
        .opportunity-card-title{
            height:50px;
            overflow:hidden;
        }
    }
.description-text{
    height:65px;
    overflow:hidden;
}
}
@media (min-width:768px){
    .opportunity-image-wrapper{
        height:auto;
        width:25%;
    }
    .location-grid{
   grid-template-columns:1fr 1fr;
    }
    .location-grid::after{
        content:'';
        position:absolute;
        width:1px;
        height:50%;
        background-color:#dbdae3;
        top:0;
        left:50%;
        transform:translate(-50%,0);
    }
    
}
.tag-link{
    align-items: center;
    background-color: #f8f7fa;
    border-radius: 48px;
    height: 36px;
    padding: 0 16px;
    display: inline-flex;
    margin-top:16px;

}
.tag-link:not(:last-child) {
    margin-right: 16px;
}
.border-none{
    border:none;
}
.opportunity-grid{
    display:grid;
    grid-template-columns:1fr;
    gap:20px;
}
@media(min-width:768px){
    .opportunity-item{
        height:320px;
    }
    .opportunity-grid{
        display:grid;
        grid-template-columns:repeat(1,1fr);
        gap:20px;
    }
}
@media(min-width:920px){
    .opportunity-grid{
        display:grid;
        grid-template-columns:repeat(1,1fr);
        gap:25px;
    }
}

.opportunity-item:hover{
   box-shadow: 0 16px 64px -16px rgb(46 55 77 / 24%);
}
.opportunity-card-title{
font-weight: 600;
 font-size: 1.125rem;
 color: #39364f; 
}
.upload-icon{
    bottom: 15px;
    right: 15px;
}
.fw-600{
    font-weight:600;
}
.orange-text{
    color: #d1410c;
}
.like-icon{
    background:#f1f1f1;
    border-radius:50%;
    height:50px;
    width:50px;
    position:absolute;
    top:170px;
    right:20px;
    display:flex;
    align-items:center;
    justify-content:center;
}
.opportunity-image{
    height:80px;
    width:80px;
    border-radius:50%;
    overflow:hidden;
}
.glassmorphic {
    background-color: rgba(0,0,0,0.2);
    text-align: center;
  }
@media(min-width:768px){
    .like-icon{
        top:125px;
    }
}
@media(min-width:920px){
    .like-icon{
        top:170px;
    }
}
.displayName {
    width: 80px;
    height: 80px;
    font-size: 16px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    // background: #1478DD;
    border:2px solid #1478DD;
    &:hover {
      text-decoration: none;
      background: #fff;
      color: #1478DD;
    }
  }
`;
export { OpportunityCardContainer };